module.exports = __webpack_public_path__ + "static/media/scoiattolo.f7065780.jpg";